export default function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-collection/src/keys.js
// module id = j0Iz
// module chunks = 0